import './duplicatesList.scss';
import {Button} from 'react-bootstrap';
import classNames from 'clsx';
import React from 'react';
import {SvgIcon} from '../../../../../icons/svgIcon';
import {Icons} from '../../../../../icons/icons';
import {HibuDocumentDuplicates} from '../../../../search-types';
import {useSearchURL} from '../../../../search-hooks';
import {URL_FILTER_PARAM} from '../../../../const';
import {useTranslation} from 'react-i18next';

export type ToggleListProps = {
    duplicates: HibuDocumentDuplicates[] | undefined;
};

export const DuplicatesList = ({duplicates}: ToggleListProps): React.JSX.Element => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = React.useState(true);
    const searchURL = useSearchURL();

    if (duplicates === undefined) {
        return <></>;
    }
    const getDuplicateLink = (docId: string): string => {
        const filter = `?${URL_FILTER_PARAM}=id[${docId}]`;
        return encodeURI(`${searchURL}${filter}`);
    };

    const renderDuplicates = () => {
        const renderedDuplicates = duplicates.map((duplicate) => (
            <li key={'id_' + duplicate.id} className={'duplicates-list-element'}>
                <a href={getDuplicateLink(duplicate.id)} target="_blank" rel="noreferrer">
                    {duplicate.contentSource}
                </a>
            </li>
        ));

        return <ol>{renderedDuplicates}</ol>;
    };

    return (
        <div className={'duplicates-list-container'}>
            <div className={'duplicates-list-header'}>
                <div
                    className={'toggle-header'}
                    onClick={() => {
                        setExpanded(!expanded);
                    }}
                >
                    <Button className={classNames('header-button', 'toggle-button')}>
                        <SvgIcon icon={Icons.CHEVRON_DOWN} className={expanded ? 'expanded' : ''} />
                    </Button>
                    <div className={'toggle-label'}>{t('search.duplicates.list_title')}</div>
                </div>
            </div>
            {expanded && renderDuplicates()}
        </div>
    );
};
